import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from "@emotion/styled";
import { MailContact } from "../icons";
export const EmailInformation = ({ isDesktop, colorText, typographyText, email, hasMap, }) => {
    const [username, domain] = email.split("@");
    const shouldShowDomain = email.includes("@");
    return (_jsxs(EmailInformationContainer, Object.assign({ isDesktop: isDesktop }, { children: [_jsx(MailIconContainer, Object.assign({ colorTexts: colorText, isDesktop: isDesktop }, { children: _jsx(MailContact, {}, void 0) }), void 0),
            _jsx(EmailText, Object.assign({ typographyTexts: typographyText, colorTexts: colorText, isDesktop: isDesktop, hasMap: hasMap }, { children: _jsxs(LinkTo, Object.assign({ colorTexts: colorText, href: `mailto:${email}` }, { children: [_jsx(LinkToWrappedText, { children: username }, void 0),
                        shouldShowDomain && (_jsx(LinkToWrappedText, { children: `@${domain}` }, void 0))] }), void 0) }), void 0)] }), void 0));
};
const EmailInformationContainer = styled.div(({ isDesktop }) => (Object.assign({ alignItems: "start", display: "flex", justifyContent: "flex-start", marginBottom: "3.2rem" }, (isDesktop
    ? {
        marginBottom: 0,
    }
    : {}))));
const EmailText = styled.p(({ typographyTexts, colorTexts, isDesktop, hasMap }) => (Object.assign({ color: colorTexts, fontFamily: typographyTexts, fontSize: "1.4rem", margin: "0 0 0 0.8rem", maxWidth: "22rem" }, (isDesktop
    ? {
        margin: "0.4rem 0 1.2rem 1.6rem",
        fontSize: "1.6rem",
        maxWidth: hasMap ? "36.2rem" : "72.4rem",
    }
    : {}))));
const MailIconContainer = styled.span(({ colorTexts, isDesktop }) => ({
    "& svg": Object.assign({ color: colorTexts, fontSize: "2rem" }, (isDesktop
        ? {
            fontSize: "2.4rem",
        }
        : {})),
}));
const LinkTo = styled.a(({ colorTexts }) => ({
    color: colorTexts,
    textDecoration: "none",
    display: "flex",
    flexWrap: "wrap",
}));
const LinkToWrappedText = styled.span({
    overflowWrap: "anywhere",
});
//# sourceMappingURL=EmailInformation.js.map